function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Box from "@limitless/modern/layout/Box";
import Button from "@limitless/modern/inputs/button/Button";
import GraduationCap from "@limitless/icons/GraduationCap";
import Paper from "@limitless/modern/surfaces/paper/Paper";
const useStyles = makeStyles(theme => ({
  imageContainer: {
    backgroundColor: theme.palette.background.white,
    height: "90px",
    width: "90px",
    borderRadius: "50%",
    boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  imageStyle: {
    width: 60
  },
  buttonContainer: {
    textAlign: "end"
  },
  defaultIcon: {
    fontSize: 38,
    color: theme.palette.secondary.contrastText
  }
}));
const KnowledgeCard = ({
  title,
  imageSource,
  ...rest
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    sx: {
      boxShadow: "0px 2px 12px -2px rgba(0, 0, 0, 0.08)",
      maxWidth: 336,
      width: 336,
      padding: "16px 0px 10px 0px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    sx: {
      padding: "16px 16px 0px 16px"
    },
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.imageContainer
  }, imageSource ? /*#__PURE__*/React.createElement("img", {
    src: imageSource,
    className: classes.imageStyle
  }) : /*#__PURE__*/React.createElement(GraduationCap, {
    viewBox: "0 0 35 29",
    className: classes.defaultIcon
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    zeroMinWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    pl: 2,
    sx: {
      color: theme => theme.palette.text.primary
    }
  }, title))), /*#__PURE__*/React.createElement(Grid, {
    pr: 1,
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, _extends({
    variant: "text",
    size: "small"
  }, rest), "View")));
};
KnowledgeCard.propTypes = {
  title: PropTypes.string.isRequired,
  imageSource: PropTypes.string
};
export default KnowledgeCard;